import React from 'react'

import { LoadingOutlined } from '@ant-design/icons'
import { Spin, SpinProps } from 'antd'

const LoadingSpin: React.FC<SpinProps> = (props: SpinProps) => {
  const spinIcon = (
    <LoadingOutlined style={{ fontSize: props.style?.fontSize ?? 20 }} spin />
  )
  return <Spin {...props} indicator={spinIcon} />
}

export default LoadingSpin
